import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import {
  PatientVisitMasterDTO,
  PatientVisitCreateRequestDTO,
  PatientVisitDeleteRequestDTO,
  PatientVisitUpdateRequestDTO,
  PatientVisitReadByHospitalIdRequestDTO,
  PatientVisitReadByMobileNoDTO,
  PatientVisitReadByIdRequestDTO,
  PatientVisitMasterListDTO,
  VisitAffiliationMappingDTO,
  VisitAffiliationMappingReadByIdRequestDTO,
  VisitAffiliationMappingCreateRequestDTO
} from "./patient-quick-registration.interface";
import { Observable } from "rxjs";
import {
  PatientVisit_Create,
  PatientVisit_Update,
  PatientVisit_Delete,
  PatientVisit_ReadAll,
  PatientVisit_ReadById,
  PatientVisit_ReadByHospitalId,
  PatientVisit_ReadByMobileNo,
  VisitAffiliationMapping_Create,
  VisitAffiliationMapping_Update,
  VisitAffiliationMapping_Delete,
  VisitAffiliationMapping_ReadById,
  VisitAffiliationMapping_ReadAll
} from "src/app/GlobalVariable/Hospital.GlobalVariable";

@Injectable({
  providedIn: "root",
})
export class PetientQuickRegistrationService {
  constructor() {}
  http = inject(HttpClient);

  patientVisit_ReadAll(): Observable<PatientVisitMasterDTO[]> {
    return this.http.get<PatientVisitMasterDTO[]>(PatientVisit_ReadAll);
  }

  PatientVisit_Create(
    data: PatientVisitCreateRequestDTO,
  ): Observable<PatientVisitMasterDTO> {
    return this.http.post<PatientVisitMasterDTO>(PatientVisit_Create, data);
  }

  PatientVisit_upate(
    data: PatientVisitUpdateRequestDTO,
  ): Observable<PatientVisitMasterDTO> {
    return this.http.post<PatientVisitMasterDTO>(PatientVisit_Update, data);
  }

  PatientVisit_Delete(data: PatientVisitDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PatientVisit_Delete, data);
  }

  PatientVisit_ReadById(
    data: PatientVisitReadByIdRequestDTO,
  ): Observable<PatientVisitMasterDTO> {
    return this.http.post<PatientVisitMasterDTO>(PatientVisit_ReadById, data);
  }

  PatientVisit_ReadByHospitalId(
    data: PatientVisitReadByHospitalIdRequestDTO,
  ): Observable<PatientVisitMasterListDTO> {
    return this.http.post<PatientVisitMasterListDTO>(
      PatientVisit_ReadByHospitalId,
      data,
    );
  }

  PetientVisit_ReadAll(): Observable<PatientVisitMasterListDTO> {
    return this.http.get<PatientVisitMasterListDTO>(PatientVisit_ReadAll);
  }

    PatientVisit_ReadByMobileNo(
    data: PatientVisitReadByMobileNoDTO,
  ): Observable<PatientVisitMasterListDTO> {
    return this.http.post<PatientVisitMasterListDTO>(
      PatientVisit_ReadByMobileNo,
      data,
    );
  }

  //visit affiliation mapping
  VisitAffiliationMapping_Create(
    data: VisitAffiliationMappingCreateRequestDTO,
  ): Observable<VisitAffiliationMappingDTO> {
    return this.http.post<VisitAffiliationMappingDTO>(VisitAffiliationMapping_Create, data);
  }

  VisitAffiliationMapping_upate(
    data: VisitAffiliationMappingDTO,
  ): Observable<VisitAffiliationMappingDTO> {
    return this.http.post<VisitAffiliationMappingDTO>(VisitAffiliationMapping_Update, data);
  }

  VisitAffiliationMapping_Delete(data: VisitAffiliationMappingDTO): Observable<void> {
    return this.http.post<void>(VisitAffiliationMapping_Delete, data);
  }

VisitAffiliationMapping_ReadById(
  data: VisitAffiliationMappingReadByIdRequestDTO,
): Observable<VisitAffiliationMappingDTO> {
  return this.http.post<VisitAffiliationMappingDTO>(
    VisitAffiliationMapping_ReadById,
    data
  );
}

VisitAffiliationMapping_ReadAll(): Observable<VisitAffiliationMappingDTO[]> {
  return this.http.get<VisitAffiliationMappingDTO[]>(VisitAffiliationMapping_ReadAll);
}
}
